import { Spinner } from "@nextui-org/react";
import React, { useState } from "react";
import { ThirdPartyVendorLayout } from "..";
import { ZButton } from "@/shared/components/button";
import ZBreadCrumbs from "@/shared/components/custom/breadcrumbs";
import { CircleHelp } from "lucide-react";
import WelcomeModal from "./WelcomeModal";

const AssessmentLoadingScreen: React.FC = () => {
  const [showHelpModal, setShowHelpModal] = useState(false);

  return (
    <ThirdPartyVendorLayout>
      <div className="w-full h-full flex flex-col">
        {/* Breadcrumb Navigation */}
        <div className="flex items-center pb-4 justify-between min-h-[44px] max-h-[44px] px-6">
          <div className="flex gap-4 items-center">
            <ZBreadCrumbs
              items={[
                { title: "Third-Party Due Diligence", href: "" }
              ]}
            />
          </div>
          <div className="flex gap-2">
            <button
              type="button"
              onClick={() => setShowHelpModal(true)}
              className="flex flex-row items-center gap-1.5 px-3 py-1 h-7 bg-white border border-[#006FEE] rounded-md transition-all hover:bg-[#F0F9FF]"
              style={{
                boxSizing: 'border-box',
                flex: 'none',
                order: 0,
                flexGrow: 0
              }}
            >
              <CircleHelp
                className="w-5 h-5 text-[#006FEE]"
                strokeWidth={1}
              />
            </button>

            {/* View Previous Responses - Disabled */}
            <ZButton
              variant="bordered"
              size="sm"
              className="text-xs font-medium h-7 px-3 bg-white border border-[#006FEE] text-[#006FEE]"
              isDisabled={true}
            >
              View Previous Responses
            </ZButton>

            {/* Submit to Customer - Disabled */}
            <ZButton
              color="primary"
              className="text-xs font-medium h-7 px-3"
              isDisabled={true}
            >
              Submit to Customer
            </ZButton>
          </div>
        </div>

        {/* Centered Loading Content */}
        <div className="flex-1 w-full flex items-center justify-center bg-white">
          <div className="flex flex-col items-center gap-4 max-w-4xl px-4">
            {/* Spinner */}
            <div className="mb-8">
              <Spinner size="lg" className="w-12 h-12" />
            </div>

            {/* Text content matching Figma specs */}
            <div
              className="flex flex-col items-center gap-4"
              style={{
                width: '100%',
                maxWidth: '1321px',
              }}
            >
              {/* Main heading */}
              <div
                className="text-center text-[#171717]"
                style={{
                  fontFamily: 'Inter',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  fontSize: '18px',
                  lineHeight: '28px',
                  maxWidth: '879px',
                }}
              >
                Assessing your responses for follow-up questions. We'll notify you by email when they're available.
              </div>

              {/* Subtext */}
              <div
                className="text-center text-[#71717A]"
                style={{
                  fontFamily: 'Inter',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  fontSize: '14px',
                  lineHeight: '20px'
                }}
              >
                This process might take up to 60 minutes. Thank you for your patience!
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Help Modal */}
      <WelcomeModal
        isOpen={showHelpModal}
        onClose={() => setShowHelpModal(false)}
        mode="help"
        progressPercentage={100}
        currentStep={2}
      />
    </ThirdPartyVendorLayout>
  );
};

export default AssessmentLoadingScreen;